
import mixx from '../../../mixin/mixin.js'


export default {
  mixins: [mixx],

  name: "barrade",
  data() {
    return {
      all: true,
      list_cuits: []

    };
  },


  created: function () {
    this.$http
      .post('/SERVER/scd/dashboard/', {
        a: 'cuitsac'
      }, {
        withCredentials: true
      })
      .then(response => {

        this.list_cuits = response.data;



      });
  },

  methods: {

    disabledasoc: function (cit) {
      console.log(cit)
      this.$http
        .post('/SERVER/scd/dashboard/', {
          a: 'discoc',
          b: cit
        }, {
          withCredentials: true
        })
        .then(response => {
          this.list_cuits = response.data;

        });
    },

    enable_all: function (cit) {

      let enb = 0;
      if (this.all) {
        enb = 1
      }
      this.$http
        .post('/SERVER/scd/dashboard/', {
          a: 'enableall',
          b: enb
        }, {
          withCredentials: true
        })
        .then(response => {
          this.list_cuits = response.data;

        });


    }

  }


};



// WEBPACK FOOTER //
// ./src/components/general/barrade/barrade.js